<template>
  <div class="con">

    <div class="safe-area">
      <div class="bar1">
        <img class="logo" :src="$env.imgUrl + 'PBLLOGO.png'" alt="">
        <div class="office page-flex-lr-top">
          <div class="office-item" v-for="item,index in offices" :key="index">
            <el-popover placement="top" trigger="hover">
              <div class="icon-box" slot="reference">
                <img class="img" :src="item.dictUrl" alt="">
                <div class="tit">{{ item.dictLabel }}</div>
              </div>
              <div>
                <img class="wechat" :src="item.remark" alt="">
                <div class="phone"><img src="https://cdn.spbcn.org/spbcnWeb/newspbcn/icon-phone.png" />{{ item.dictValue }}</div>
              </div>
            </el-popover>
          </div>
        </div>
      </div>
    </div>
    <div class="bar2">
      <div class="safe-area flex">
        <div>
          <div>400-0863-988</div>
          <div>北京市朝阳区光华路4号院3号楼5层603</div>
        </div>
        <div>© 2014-2026 spbcn.org 版权所有 | 京ICP备17055067号-1</div>
        <div class="icons">
          <el-popover placement="top" trigger="hover">
            <img src="https://cdn.spbcn.org/spbcnWeb/newspbcn/erweima.png" alt="">
            <div class="icon-box" slot="reference"><img src="https://cdn.spbcn.org/spbcnWeb/newspbcn/wechat.png" alt=""></div>
          </el-popover>
          <el-popover placement="top" trigger="hover">
            <img src="https://cdn.spbcn.org/spbcnWeb/newspbcn/weibo.jpg" alt="">
            <div class="icon-box" slot="reference"><img src="https://cdn.spbcn.org/spbcnWeb/newspbcn/sina.png" alt=""></div>
          </el-popover>
          <el-popover placement="top" trigger="hover">
            <img src="https://cdn.spbcn.org/spbcnWeb/newspbcn/douyin.png" alt="">
            <div class="icon-box" slot="reference"><img src="https://cdn.spbcn.org/spbcnWeb/newspbcn/dou.png" alt=""></div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      offices: [
        { title: '北京代表处', img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo1.png', wechat: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-beijing.png', phone: '13683692870' },
        { title: '天津代表处', img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo2.png', wechat: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-tianjin.jpg', phone: '15510803713' },
        { title: '华东代表处', img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo3.png', wechat: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-huadong.png', phone: '18016372779' },
        { title: '华南代表处', img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo4.png', wechat: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-huanan.jpg', phone: '13147018191' },
        { title: '西南代表处', img: 'https://cdn.spbcn.org/spbcnappneed/lianxi_logo5.png', wechat: 'https://cdn.spbcn.org/spbcnapp/2025ui/qr-xinan.jpg', phone: '18982180797' }
      ]
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$http.get('https://dev.spbcn.org/web/common/dict/queryDictList?dictType=customer_service').then(res => {
        if (res.code === 200) {
          this.offices = res.data.filter((item, index) => index !== 0).map(item => {
            item.dictLabel = item.dictLabel.split('SPBCN ')[1]
            return item
          })
        }
      })
    }
  }
}
</script>

<style>
.con{
  background-color: #202020;
}
.bar1{
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid rgba(255, 255, 255, .2);
  padding-bottom: 40px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .logo{
    height: 54px;
    margin-top: 12px;
  }
}
.bar2{
  color: #FFF;
  padding: 20px 0 40px;
  font-size: 12px;
  line-height: 20px;
  .flex{
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

}
.icons{
  display: flex;
  align-items: center;
  .icon-box{
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #FFF;
    border-radius: 6px;
    margin: 0 4px;
    cursor: pointer;
    img{
      width: 20px;
    }
    &:hover{
      background-color: rgba(255, 255, 255, .2);
    }
  }
}
.office{
  justify-content: center;
  margin-top: 20px;
  .office-item{
    width: 70px;
    cursor: pointer;
  }
  .img{
    width: 36px;
    height: 36px;
    display: block;
    margin: 0 auto 12px;
  }
  .tit{
    text-align: center;
    font-size: 10px;
    color: rgba(255, 255, 255, .3);
  }
}

.wechat{
  display: block;
  margin: 0 auto 6px;
  width: 160px;
  height: auto;
}
.phone{
  img{
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: alih;
  color: #000;
}

</style>
